
import React from 'react';
import { Card } from "@/components/ui/card";
import { Lightbulb, User, Heart, Briefcase } from 'lucide-react';

interface BioGuidanceProps {
  occupation?: string;
  education?: string;
  showTips: boolean;
}

export const BioGuidance: React.FC<BioGuidanceProps> = ({ 
  occupation, 
  education, 
  showTips 
}) => {
  if (!showTips) return null;

  const getPersonalizedSuggestions = () => {
    const suggestions = [];
    
    if (occupation) {
      suggestions.push(`Fale sobre sua experiência como ${occupation.toLowerCase()}`);
    }
    
    if (education) {
      suggestions.push(`Mencione sua formação em ${education.toLowerCase()}`);
    }
    
    return suggestions;
  };

  const personalizedSuggestions = getPersonalizedSuggestions();

  return (
    <Card className="bg-black/20 border-white/10 p-4 space-y-3">
      <div className="flex items-center gap-2 mb-3">
        <Lightbulb className="h-4 w-4 text-blue-400" />
        <span className="text-sm font-medium text-blue-400">Dicas para sua biografia</span>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-start gap-2">
          <User className="h-3 w-3 text-white/60 mt-0.5" />
          <span className="text-xs text-white/70">Conte sobre sua personalidade e hobbies</span>
        </div>
        
        <div className="flex items-start gap-2">
          <Briefcase className="h-3 w-3 text-white/60 mt-0.5" />
          <span className="text-xs text-white/70">Descreva brevemente sua profissão</span>
        </div>
        
        <div className="flex items-start gap-2">
          <Heart className="h-3 w-3 text-white/60 mt-0.5" />
          <span className="text-xs text-white/70">Explique o que busca em um relacionamento</span>
        </div>
        
        {personalizedSuggestions.length > 0 && (
          <div className="mt-3 pt-2 border-t border-white/10">
            <span className="text-xs font-medium text-white/80 block mb-1">Sugestões personalizadas:</span>
            {personalizedSuggestions.map((suggestion, index) => (
              <div key={index} className="flex items-start gap-2">
                <span className="text-blue-400 text-xs">•</span>
                <span className="text-xs text-blue-300">{suggestion}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="mt-3 pt-2 border-t border-white/10">
        <p className="text-xs text-white/60">
          <strong>Exemplo:</strong> "Sou advogada apaixonada por direito empresarial. Nas horas vagas, adoro viajar e conhecer novas culturas. Busco alguém para compartilhar experiências e construir uma relação baseada em confiança e cumplicidade."
        </p>
      </div>
    </Card>
  );
};
